import AppConfig from "../constants/AppConfig";

export const handlePressEnter = (id) => {
  const listener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      document.getElementById(id).click();
    }
  };

  return listener;
}

export const validateIP = (ip) => {
  let regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return regex.test(ip);
}

export const validateNumber = (ssw) => {
  let regex = /^([0-9]*)$/;
  return regex.test(ssw);
}

export const validateEmail = (email) => {
  let regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return regex.test(email);
}

export const validateToken = (tokenTimer) => {
  const timeoutTime = AppConfig.token_expire;
  return tokenTimer + timeoutTime > Date.now();
}